<template v-if="tableData">
    <div class="grid">
        <div class="col">
            <Paginator
                :rows="rowsPerPage"
                :totalRecords="rowsTotal"
                :rowsPerPageOptions="rowsPerPageOptions"
                @page="onChangePage"
            />
        </div>
    </div>
    <div class="grid">
        <div class="col">
            <DataTable
                ref="table"
                :value="tableData"
                scrollable
                :sortField="sortField"
                :sortOrder="getSortOrder"
            >
                <slot></slot>
            </DataTable>
        </div>
    </div>
    <div class="grid">
        <div class="col">
            <Paginator
                :rows="rowsPerPage"
                :totalRecords="rowsTotal"
                :rowsPerPageOptions="rowsPerPageOptions"
                @page="onChangePage"
            />
        </div>
    </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Paginator from "primevue/paginator";

export default {
    name: "TableReport",
    props: {
        rowsPerPage: {
            type: Number,
            required: true,
        },
        rowsTotal: {
            type: Number,
            required: true,
        },
        onChangePage: {
            type: Function,
            required: true,
        },
        tableData: {
            type: Array,
            required: true,
        },
        sortField: {
            type: String,
            required: true,
        },
        sortOrder: {
            type: String,
            required: true,
        }
    },
    data() {
        return {
            rowsPerPageOptions: [5, 10, 25, 50, 150, 200, 500],
        };
    },
    computed: {
        getSortOrder() {
            return this.sortOrder === 'desc' ? -1 : 1;
        }
    },
    components: {
        DataTable,
        Paginator,
    }
}
</script>
